import { render, staticRenderFns } from "./TestResultList.vue?vue&type=template&id=bd63a034&scoped=true"
import script from "./TestResultList.vue?vue&type=script&lang=js"
export * from "./TestResultList.vue?vue&type=script&lang=js"
import style0 from "./TestResultList.vue?vue&type=style&index=0&id=bd63a034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd63a034",
  null
  
)

export default component.exports